 //This is a auto-generated file, please not erased it or edit it manually, find this string is package.json to modify it. 
export const versionApp = "1.3.8";
export const month = "abril";
export const year = "2022";
